import { ROUTES } from '@/constants/routes';
import { LoginCredentials } from '@/types/auth';
import { useMutation } from '@tanstack/react-query';
import { setLocale } from '@treyd-io/core/utils/locale';
import { useToastNotification } from '@treyd-io/treyd-ui/hooks/useToastNotification';
import { signIn } from 'next-auth/react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';

export const useCredentialsLogin = () => {
  const showToastMessage = useToastNotification();
  const router = useRouter();
  const { t } = useTranslation();
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl');

  return useMutation({
    mutationFn: ({ email, password }: LoginCredentials) =>
      signIn('credentials', {
        email,
        password,
        redirect: false,
        callbackUrl: callbackUrl || ROUTES.home,
      }),

    onError: () =>
      showToastMessage({
        message: t('something_went_wrong'),
        type: 'error',
      }),

    onSuccess: (response) => {
      setLocale(navigator.language);
      response?.error
        ? showToastMessage({ message: response.error, type: 'error' })
        : router.push(callbackUrl || ROUTES.home);
    },
  });
};
